module.exports = __webpack_public_path__ + "static/media/patternCard.b7f1d67d.jpg";